import { Component } from '@angular/core';
import { AnimateModule, GtmClickDirective, TrainingBrand, WwwRouteSlug } from '@pro-connect/shared';
import { BrandSection } from '../../models/brand-section';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-brand-dedicated-trainings',
  templateUrl: './brand-dedicated-trainings.component.html',
  styleUrls: ['./brand-dedicated-trainings.component.scss'],
  imports: [AnimateModule, NgOptimizedImage, RouterLink, GtmClickDirective],
})
export class BrandDedicatedTrainingsComponent {
  protected readonly BrandSection = BrandSection;
  protected readonly Brand = TrainingBrand;
  protected readonly WwwRouteSlug = WwwRouteSlug;
}
